// client/src/constants/themes.js

export const THEMES = {
  indigo:   { primary: '#7C8CFF', secondary: '#FF7AC3' },
  purple:   { primary: '#A78BFA', secondary: '#F472B6' },
  teal:     { primary: '#2DD4BF', secondary: '#38BDF8' },
  rose:     { primary: '#FB7185', secondary: '#F9A8D4' },
  amber:    { primary: '#FBBF24', secondary: '#FB923C' },
  emerald:  { primary: '#34D399', secondary: '#60A5FA' },
  crimson:  { primary: '#F43F5E', secondary: '#C084FC' },
  midnight: { primary: '#94A3B8', secondary: '#67E8F9' },
};

export const THEME_LABELS = {
  indigo:   'Indigo',
  purple:   'Purple',
  teal:     'Teal',
  rose:     'Rose',
  amber:    'Amber',
  emerald:  'Emerald',
  crimson:  'Crimson',
  midnight: 'Midnight',
};
